import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEnquiryModel } from "../enquiryModel";
import { tableSize } from "@/utils/constants";
import { DetailModel } from "./DetailModel"
import useNavModel from "@/model/navModel";
import YhTootip from "@/components/YhTootip";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, loading,
        loadData, setSelectedRowKeys, setDescRows
    } = useEnquiryModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const [detail, setDetail] = useState<{ visible: boolean, code: string }>({ visible: false, code: "" });

    useEffect(() => {
        loadData()
    }, [])

    const defaultColumns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        },
        {
            title: '操作',
            key: 'action',
            width: 60,
            align: 'center',
            render: (text: any, record: any,) => <YhTootip text="询价历史" style={{ width: 60 }} onClick={() => { setDetail({ visible: true, code: record.code }); }} />
        },
        {
            title: '配件编码',
            dataIndex: 'code',
            width: 120,
            align: 'center',
        },
        {
            title: '配件名称',
            dataIndex: 'name',
            width: 200,
            align: 'center',
        },
        {
            title: '询价次数',
            dataIndex: 'num',
            width: 80,
            align: 'center',
        },
        {
            title: '生效中询价单号',
            dataIndex: 'enquiryCode',
            width: 120,
            align: 'center',
        },
        {
            title: '生效中供应商名称',
            dataIndex: 'supplierName',
            width: 150,
            align: 'center',
        },
        {
            title: '生效中含税单价',
            dataIndex: 'offerPrice',
            width: 120,
            align: 'center',
        },
        {
            title: '审批日期',
            dataIndex: 'approvalTime',
            width: 150,
            align: 'center',
        },
        {
            title: '截止日期',
            dataIndex: 'endTime',
            width: 150,
            align: 'center',
        },
    ];

    //点击行选高亮
    const onRow = (record: any) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record: any) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    return (
        <>
            <Table
                bordered
                style={{ cursor: "pointer" }}
                loading={loading}
                size={tableSize}
                rowKey={record => record.code as string}
                rowSelection={{
                    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                        setDescRows(selectedRows)
                    },
                    selectedRowKeys
                }}
                columns={defaultColumns}
                dataSource={dataSource}
                rowClassName={(record) => {
                    if (record?.isExpired) return "background-FFB4B4";
                    return ""
                }}
                pagination={{
                    showSizeChanger: true,
                    ...pgCfg,
                    defaultPageSize: 25,
                    pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                    position: ["bottomRight"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                onRow={record => ({
                    onClick: () => onRow(record as any),
                    onContextMenu: (e) => {
                        e.preventDefault();
                        // setSelectedRowKeys([record.id as string]);
                        onRightClick(record)
                    }

                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}

            />

            <DetailModel
                visible={detail.visible}
                code={detail.code}
                onCancel={() => { setDetail({ visible: false, code: "" }); }}
            />
        </>
    )
}
